var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "logotype",
      class: { "logotype--large": _vm.large, "logotype--white": _vm.white },
      attrs: { href: _vm.route("home") }
    },
    [
      _c("img", {
        staticClass: "logotype__image",
        style: "width: " + _vm.width + ";height: " + _vm.height,
        attrs: { src: _vm.src, alt: "KERP" }
      }),
      _vm._v(" "),
      _vm.title || _vm.subTitle
        ? _c("div", { staticClass: "logotype__header" }, [
            _vm.title
              ? _c("span", { staticClass: "logotype__title" }, [
                  _vm._v(_vm._s(_vm.title))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.subTitle
              ? _c("small", { staticClass: "logotype__subtitle" }, [
                  _vm._v(_vm._s(_vm.subTitle))
                ])
              : _vm._e()
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6add256e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6add256e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/layout/Logo.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6add256e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/layout/Logo.vue
// module chunks = 0